import { z } from 'zod';
import { emailSchema, parentPasswordSchema } from './auth.js';

export const updateProfileSchema = z.object({
  displayName: z.string().trim().min(1).max(80),
});
export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;

export const changeEmailSchema = z.object({
  newEmail: emailSchema,
  /** Re-authentication: the account's current password. */
  currentPassword: z.string().min(1).max(200),
});
export type ChangeEmailInput = z.infer<typeof changeEmailSchema>;

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1).max(200),
  newPassword: parentPasswordSchema,
});
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

/** Scheduling account deletion requires re-auth with the current password. */
export const deleteAccountSchema = z.object({
  currentPassword: z.string().min(1).max(200),
});
export type DeleteAccountInput = z.infer<typeof deleteAccountSchema>;

/** Days a deleted account is recoverable before it is permanently purged. */
export const ACCOUNT_DELETION_GRACE_DAYS = 30;
